import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FORGOT_PASSWORD_FLOW, GENERAL_STYLE } from '../constants';
import LoginCard from '../../../components/LoginCard';
import Heading from '../../../../../generic-components/Heading';
import { LoginHelpNavBar } from '../LoginHelpNavBar';
import { LoginHelpOption } from '../LoginHelpOption';
import { ReactComponent as PhoneCall } from '../../../../../assets/icons/svg/colored-icons/ic-colored-phone-call.svg';
import { ReactComponent as TextMessage } from '../../../../../assets/icons/svg/colored-icons/ic-colored-sms.svg';

import Spinner, { SpinnerColor } from '../../../../../generic-components/Spinner';
import { ForgotPasswordGeneralErrorModal } from '../Errors/ForgotPasswordGeneralErrorModal';
import { Layout } from '../../../../../components/Layout/Layout';

export const MFA_METHOD = {
  SMS: 'SMS',
  VOICE: 'VOICE',
};
interface IProps {
    onClose: () => void
    onBack: () => void
    isLoading: boolean
    onOptionSelected: (selectedOption: string) => void
}
const ForgotPasswordMFMethodStep = ({
  onClose, onBack, onOptionSelected, isLoading,
}: IProps) => {
  const { t } = useTranslation();
  const [mfaType, setMFAType] = useState<string>(MFA_METHOD.SMS);
  const [showError, setShowError] = useState<boolean>(false);

  const optionSelectedHandler = (selectedOption: string) => {
    onOptionSelected(selectedOption);
    setMFAType(selectedOption);
  };
  const heading = (
    <Heading
      title={t(FORGOT_PASSWORD_FLOW.MFA_METHOD.TITLE)}
      className={`${GENERAL_STYLE.HEADING.CLASS_NAME} mb-[16px]`}
    />
  );
  const subtitle = (
    <Heading
      title={t(FORGOT_PASSWORD_FLOW.MFA_METHOD.SUBTITLE)}
      className={`${GENERAL_STYLE.DESCRIPTION.CLASS_NAME} mb-[40px]`}
    />
  );
  const errorModal = (

    showError && (
    <ForgotPasswordGeneralErrorModal
      title={t(FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_TITLE)}
      description={t(FORGOT_PASSWORD_FLOW.ERRORS.GENERAL_ERROR_DESCRIPTION)}
      onAction={() => {
        setShowError(false);
        onOptionSelected(mfaType);
      }}
      onClose={() => { setShowError(false); }}
    />
    )

  );
  return (
    <Layout shouldHideProfile shouldHideChatBot wrapperClassName='pt-[78px] pl-[72px] ml-[100px] pc-md:ml-[256px]'>
      <LoginHelpNavBar
        onBackClick={onBack}
        onCloseClick={onClose}
      />

      <LoginCard className={GENERAL_STYLE.LOGIN_CARD.CLASS_NAME}>
        <div className='flex flex-col justify-between h-full'>

          <div>
            {heading}
            {subtitle}
            {errorModal}

            {(isLoading) && <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />}
            <div className={`${isLoading ? 'opacity-0' : 'opacity-100'}`}>
              <LoginHelpOption
                title={t(FORGOT_PASSWORD_FLOW.MFA_METHOD.SMS_METHOD)}
                icon={<TextMessage />}
                onClick={() => optionSelectedHandler(MFA_METHOD.SMS)}
                testId='mfa_method_sms'
              />
              <LoginHelpOption
                title={t(FORGOT_PASSWORD_FLOW.MFA_METHOD.CALL_METHOD)}
                icon={<PhoneCall />}
                onClick={() => optionSelectedHandler(MFA_METHOD.VOICE)}
                testId='mfa_method_voice'
              />
            </div>

          </div>

        </div>
      </LoginCard>
    </Layout>

  );
};

export default ForgotPasswordMFMethodStep;
